module.exports = __webpack_public_path__ + "c769ca8bb37f7a0dacb09acbc40d64a6.fbx";